var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-col',{attrs:{"md":"10","offset-md":"1"}},[_c('div',{staticClass:"editor-wrap bg-white p-5",attrs:{"id":"econtent"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }